import React from 'react'
import { object, array, string } from 'prop-types'

class LocationRichSnippets extends React.Component {
  getDataFromFeed () {
    const { location } = this.props
    try {
      const locationData = require('../../../../../config/exports/buildTimeOnly/reviews/' + this.getFeedPath() + location.code + '.json')
      return locationData
    } catch (e) {
      return false
    }
  }

  getFeedPath () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return 'parking/meta/'
      case 'HCP':
        return 'hotels/meta/'
      case 'HO':
        return 'hotels/meta/'
      case 'LO':
        return 'lounges/meta/'
    }

    return ''
  }

  renderFeedData (feedData) {
    const { functionParams } = this.props
    let option = 'reviews'
    if (functionParams && functionParams[0]) {
      switch (functionParams[0]) {
        case 'percentage':
          return feedData.scoreAsPercentage + '%'
      }
    }
    // Formats numbers like 1000000.57 to 1,000,000.57
    return feedData[option].toFixed(0).replace(/./g, function (c, i, a) {
      return i && c !== '.' && ((a.length - i) % 3 === 0) ? ',' + c : c
    })
  }

  render () {
    const { id } = this.props
    const feedData = this.getDataFromFeed()
    return (
      <span id={id} className='priceSmall'>
        { feedData && this.renderFeedData(feedData) }
      </span>
    )
  }
}

LocationRichSnippets.propTypes = {
  id: string.isRequired,
  pageData: object.isRequired,
  location: object,
  functionParams: array
}

export default LocationRichSnippets



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/location-rich-snippets.jsx